import { cn, ClassValue } from "@/libs/utils/tailwind/cn";

export default function HomeownerIcon({ className }: Props) {
  return (
    <svg
      className={cn(className)}
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 20 18"
    >
      <path
        d="M7.50008 17V10.8333C7.50008 10.3666 7.50008 10.1333 7.59091 9.95501C7.67081 9.79821 7.79829 9.67072 7.95509 9.59083C8.13335 9.5 8.36671 9.5 8.83342 9.5H11.1668C11.6335 9.5 11.8668 9.5 12.0451 9.59083C12.2019 9.67072 12.3294 9.79821 12.4093 9.95501C12.5001 10.1333 12.5001 10.3666 12.5001 10.8333V17M1.66675 7.41667L9.20008 1.76667C9.48697 1.5515 9.63041 1.44392 9.78795 1.40245C9.927 1.36585 10.0732 1.36585 10.2122 1.40245C10.3698 1.44392 10.5132 1.55151 10.8001 1.76667L18.3334 7.41667M3.33342 6.16667V14.3333C3.33342 15.2668 3.33342 15.7335 3.51507 16.09C3.67486 16.4036 3.92983 16.6586 4.24343 16.8183C4.59995 17 5.06666 17 6.00008 17H14.0001C14.9335 17 15.4002 17 15.7567 16.8183C16.0703 16.6586 16.3253 16.4036 16.4851 16.09C16.6668 15.7335 16.6668 15.2668 16.6668 14.3333V6.16667L11.6001 2.36667C11.0263 1.93634 10.7394 1.72118 10.4244 1.63824C10.1462 1.56503 9.85392 1.56503 9.57581 1.63824C9.26073 1.72118 8.97385 1.93634 8.40008 2.36667L3.33342 6.16667Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

interface Props {
  className?: ClassValue;
}
